import { ItemStatus } from "@/services/collection/item";
import { revertMap } from "@/utilities/map";

export enum ItemStatusUrlString {
  InMyCollection = "collection",
  NotInCollection = "notInCollection",
  OnMarketplace = "marketplace",
  Archived = "history",
}

export const ItemStatusToUrlString: Record<ItemStatus, ItemStatusUrlString> = {
  [ItemStatus.InMyCollection]: ItemStatusUrlString.InMyCollection,
  [ItemStatus.OnMarketplace]: ItemStatusUrlString.OnMarketplace,
  [ItemStatus.Archived]: ItemStatusUrlString.Archived,
  [ItemStatus.NotInCollection]: ItemStatusUrlString.NotInCollection,
};

export const UrlStringToItemStatus = revertMap(ItemStatusToUrlString);
